export default "__VITE_ASSET__CcwVOoEA__"